module.exports = __webpack_public_path__ + "media/img/scholarships/Maths-95089be62b43f3d3f5d91458cfcc98e8.png";